import { useTranslation } from "react-i18next";
import { useAxios } from "../useAxios"
import { useQuery } from "@tanstack/react-query";

export const useGetReportsDate = () => {

    const axios = useAxios();
    const {t} = useTranslation();

    const fetchReportsDate = async () => {
        try {
            const { data } = await axios.get(`/api/reports/examInstanceDate`);
            return data;
        } catch (error) {
            throw new Error(t("messages.error.getReportsDate"));
        }
    }

    return useQuery({queryKey: ["reportsDate"], queryFn: fetchReportsDate, staleTime: Infinity})
}